import Icon from '@ant-design/icons';
import * as React from 'react';

const MapFieldsSvg = () => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8 7.422v-3.91a.889.889 0 00-.559-.826l-3.556-1.422a.889.889 0 00-.66 0L6.241 2.778a.889.889 0 01-.66 0L2.076 1.376a.444.444 0 00-.61.415v8.517c0 .363.222.69.56.825l3.555 1.422a.888.888 0 00.66 0M5.911 2.84v4.582M10.355 1.2v4"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M10.8 13.645a3.111 3.111 0 100-6.222 3.111 3.111 0 000 6.222z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8 14.533l-1.786-1.786"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const MapFieldsIcon = (props: any) => (
  <Icon component={MapFieldsSvg} {...props} />
);

export default MapFieldsIcon;
